// src/components/Header.js
import React, { useState } from 'react'; // Import useState
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <div className="logo">IronBhai</div>

      {/* Hamburger Icon - Visible only on mobile */}
      <button className="menu-toggle" onClick={toggleMenu}>
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
        <span className="hamburger-icon"></span>
      </button>

      {/* Navigation - Conditionally rendered/styled based on isMenuOpen */}
      <nav className={isMenuOpen ? 'open' : ''}> {/* Add 'open' class when menu is open */}
        <ul>
          <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
          <li><a href="/#services" onClick={() => setIsMenuOpen(false)}>Services</a></li>
          <li><Link to="/about-us" onClick={() => setIsMenuOpen(false)}>About Us</Link></li>
          <li><a href="/#contact" onClick={() => setIsMenuOpen(false)}>Contact</a ></li>
          <li><Link to="/cancellation-policy" onClick={() => setIsMenuOpen(false)}>Cancellation Policy</Link></li>
          <li><Link to="/terms-and-conditions" onClick={() => setIsMenuOpen(false)}>Terms & Conditions</Link></li>
          <li><Link to="/refund-policy" onClick={() => setIsMenuOpen(false)}>Refund Policy</Link></li>
          <li><Link to="/privacy-policy" onClick={() => setIsMenuOpen(false)}>Privacy Policy</Link></li>
          <li><Link to="/faq" onClick={() => setIsMenuOpen(false)}>FAQ</Link></li>
          {/* <li><Link to="/shipping-policy">Shipping Policy</Link></li> */}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
